<template>
  <div
    :class="[
      $style.separator,
      {
        [$style.separatorIsHorizontal]: isHorizontal,
      },
    ]"
  >
    <div :class="$style.separatorInside" />
  </div>
</template>

<script setup>
  defineProps({
    isHorizontal: {
      type: Boolean,
      default: false,
    },
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
.separator {
  position: relative;
  display: flex;

  &::before {
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    content: "";
    border: 0.5px dashed $color-dash-separator;
    translate: -0.5px;
  }

  &Inside {
    position: absolute;
    top: 0;
    bottom: 0;
    display: flex;
    overflow: hidden;
    justify-content: space-between;

    &::before,
    &::after {
      display: block;
      width: 24px;
      height: 24px;
      content: "";
      border-radius: 50%;
      background: $color-background-1;
    }
  }

  &:not(&IsHorizontal) {
    width: 0;
  }

  &:not(&IsHorizontal) &Inside {
    flex-direction: column;
    translate: -50% 0;

    &::before,
    &::after {
      margin: -12px 0;
    }
  }

  &IsHorizontal &Inside {
    width: 100%;
    height: 24px;
    translate: 0 -50%;

    &::before,
    &::after {
      margin: 0 -12px;
    }
  }
}
</style>
